import {
  Language,
  SigningMethod,
  SourceName,
} from '../../../enums/const-enums';

export interface RassFooterTranslations {
  info: {
    [SigningMethod.RANDOM_READER]: string;
  };
  button: {
    label: {
      up: {
        left: Record<SourceName, string>;
        right: {
          [SigningMethod.EOTP]: string;
          [SigningMethod.QR]: string;
          [SigningMethod.RABO_SCANNER]: string;
          [SigningMethod.RANDOM_READER]: string;
          [SigningMethod.TIN_WEB]: string;
        };
      };
      down: {
        [SigningMethod.EOTP]: string;
        [SigningMethod.QR]: string;
        [SigningMethod.RABO_SCANNER]: string;
        [SigningMethod.RANDOM_READER]: string;
        [SigningMethod.TIN_WEB]: string;
      };
    };
  };
  cta: {
    text: Record<SourceName, string>;
    href: Record<SourceName, string>;
  };
}

const nlTranslations: RassFooterTranslations = {
  info: {
    [SigningMethod.RANDOM_READER]:
      'De Random Reader Comfort heeft grote toetsen en kan voorlezen. Heb jij moeite met lezen of zien? Dan wordt internetbankieren hierdoor wat makkelijker. Vraag bij jouw Rabobank of de Random Reader Comfort voor jou geschikt is. We helpen je graag!',
  },
  button: {
    label: {
      up: {
        left: {
          [SourceName.EMANDATES]: 'Ondertekenen',
          [SourceName.IDEAL]: 'Betalen',
          [SourceName.WERO]: 'Betalen',
          [SourceName.IDIN]: 'Ondertekenen',
          [SourceName.LOGIN]: 'Inloggen',
          [SourceName.OTHER]: 'Ondertekenen',
        },
        right: {
          [SigningMethod.EOTP]: 'met e-mail',
          [SigningMethod.QR]: 'met een',
          [SigningMethod.RABO_SCANNER]: 'met de',
          [SigningMethod.RANDOM_READER]: 'met de',
          [SigningMethod.TIN_WEB]: 'met',
        },
      },
      down: {
        [SigningMethod.EOTP]: 'en eenmalig wachtwoord',
        [SigningMethod.QR]: 'QR-code en de Rabo App',
        [SigningMethod.RABO_SCANNER]: 'Rabo Scanner',
        [SigningMethod.RANDOM_READER]: 'Random Reader Comfort',
        [SigningMethod.TIN_WEB]: 'je toegangscode',
      },
    },
  },
  cta: {
    text: {
      [SourceName.EMANDATES]: 'Hulp bij ondertekenen',
      [SourceName.IDEAL]: 'Hulp bij betalen met iDEAL',
      [SourceName.WERO]: 'Hulp bij betalen met WERO',
      [SourceName.IDIN]: 'Hulp bij ondertekenen',
      [SourceName.LOGIN]: 'Hulp bij inloggen',
      [SourceName.OTHER]: 'Hulp bij ondertekenen',
    },
    href: {
      [SourceName.EMANDATES]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.IDEAL]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-ideal/',
      [SourceName.WERO]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-wero/',
      [SourceName.IDIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.LOGIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.OTHER]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
    },
  },
};

const enTranslations: RassFooterTranslations = {
  info: {
    [SigningMethod.RANDOM_READER]:
      'The Random Reader Comfort has large keys and can read aloud. Is reading or seeing hard for you? Then this can make internet banking easier. Ask your Rabobank if the Random Reader Comfort is suitable for your situation. We are happy to help.',
  },
  button: {
    label: {
      up: {
        left: {
          [SourceName.EMANDATES]: 'Sign',
          [SourceName.IDEAL]: 'Pay',
          [SourceName.WERO]: 'Pay',
          [SourceName.IDIN]: 'Sign',
          [SourceName.LOGIN]: 'Login',
          [SourceName.OTHER]: 'Sign',
        },
        right: {
          [SigningMethod.EOTP]: 'using email',
          [SigningMethod.QR]: 'using a QR code',
          [SigningMethod.RABO_SCANNER]: 'using the',
          [SigningMethod.RANDOM_READER]: 'using the',
          [SigningMethod.TIN_WEB]: 'using',
        },
      },
      down: {
        [SigningMethod.EOTP]: 'and one-time password',
        [SigningMethod.QR]: 'and the Rabo App',
        [SigningMethod.RABO_SCANNER]: 'Rabo Scanner',
        [SigningMethod.RANDOM_READER]: 'Random Reader Comfort',
        [SigningMethod.TIN_WEB]: 'your access code',
      },
    },
  },
  cta: {
    text: {
      [SourceName.EMANDATES]: 'Help with signing',
      [SourceName.IDEAL]: 'Help with iDEAL',
      [SourceName.WERO]: 'Help with WERO',
      [SourceName.IDIN]: 'Help with signing',
      [SourceName.LOGIN]: 'Help with logging in',
      [SourceName.OTHER]: 'Help with signing',
    },
    href: {
      [SourceName.EMANDATES]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.IDEAL]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-ideal/',
      [SourceName.WERO]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-wero/',
      [SourceName.IDIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.LOGIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.OTHER]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
    },
  },
};

const esTranslations: RassFooterTranslations = {
  info: {
    [SigningMethod.RANDOM_READER]:
      'The Random Reader Comfort has large keys and can read aloud. Is reading or seeing hard for you? Then this can make internet banking easier. Ask your Rabobank if the Random Reader Comfort is suitable for your situation. We are happy to help.',
  },
  button: {
    label: {
      up: {
        left: {
          [SourceName.EMANDATES]: 'Sign',
          [SourceName.IDEAL]: 'Pay',
          [SourceName.WERO]: 'Pay',
          [SourceName.IDIN]: 'Sign',
          [SourceName.LOGIN]: 'Iniciar',
          [SourceName.OTHER]: 'Sign',
        },
        right: {
          [SigningMethod.EOTP]: 'usando correo electrónico',
          [SigningMethod.QR]: 'usando un código',
          [SigningMethod.RABO_SCANNER]: 'usando el',
          [SigningMethod.RANDOM_READER]: 'usando el',
          [SigningMethod.TIN_WEB]: 'usando',
        },
      },
      down: {
        [SigningMethod.EOTP]: 'y password de un solo uso',
        [SigningMethod.QR]: 'QR y la Rabo App',
        [SigningMethod.RABO_SCANNER]: 'Rabo Scanner',
        [SigningMethod.RANDOM_READER]: 'Random Reader Comfort',
        [SigningMethod.TIN_WEB]: 'su código de acceso',
      },
    },
  },
  cta: {
    text: {
      [SourceName.EMANDATES]: 'Help with signing',
      [SourceName.IDEAL]: 'Help with iDEAL',
      [SourceName.WERO]: 'Help with WERO',
      [SourceName.IDIN]: 'Help with signing',
      [SourceName.LOGIN]: 'Ayuda para iniciar sesión',
      [SourceName.OTHER]: 'Help with signing',
    },
    href: {
      [SourceName.EMANDATES]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.IDEAL]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-ideal/',
      [SourceName.WERO]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-wero/',
      [SourceName.IDIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.LOGIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.OTHER]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
    },
  },
};

const ptTranslations: RassFooterTranslations = {
  info: {
    [SigningMethod.RANDOM_READER]:
      'The Random Reader Comfort has large keys and can read aloud. Is reading or seeing hard for you? Then this can make internet banking easier. Ask your Rabobank if the Random Reader Comfort is suitable for your situation. We are happy to help.',
  },
  button: {
    label: {
      up: {
        left: {
          [SourceName.EMANDATES]: 'Sign',
          [SourceName.IDEAL]: 'Pay',
          [SourceName.WERO]: 'Pay',
          [SourceName.IDIN]: 'Sign',
          [SourceName.LOGIN]: 'Faça login',
          [SourceName.OTHER]: 'Sign',
        },
        right: {
          [SigningMethod.EOTP]: 'usando e-mail',
          [SigningMethod.QR]: 'usando um',
          [SigningMethod.RABO_SCANNER]: 'usando o',
          [SigningMethod.RANDOM_READER]: 'usando o',
          [SigningMethod.TIN_WEB]: 'usando',
        },
      },
      down: {
        [SigningMethod.EOTP]: 'y uma senha de uso único',
        [SigningMethod.QR]: 'código QR e o Rabo App',
        [SigningMethod.RABO_SCANNER]: 'Rabo Scanner',
        [SigningMethod.RANDOM_READER]: 'Random Reader Comfort',
        [SigningMethod.TIN_WEB]: 'seu código de acesso',
      },
    },
  },
  cta: {
    text: {
      [SourceName.EMANDATES]: 'Help with signing',
      [SourceName.IDEAL]: 'Help with iDEAL',
      [SourceName.WERO]: 'Help with WERO',
      [SourceName.IDIN]: 'Help with signing',
      [SourceName.LOGIN]: 'Ajuda para fazer login',
      [SourceName.OTHER]: 'Help with signing',
    },
    href: {
      [SourceName.EMANDATES]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.IDEAL]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-ideal/',
      [SourceName.WERO]:
        'https://www.rabobank.nl/particulieren/online-bankieren/betalen-met-wero/',
      [SourceName.IDIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.LOGIN]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
      [SourceName.OTHER]:
        'https://www.rabobank.nl/particulieren/betalen/service/online-bankieren/inloggen-ondertekenen/',
    },
  },
};

export const rassFooterTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: esTranslations,
  [Language.PT]: ptTranslations,
};
